import React from "react";

import FieldProto from "../../proto/field-proto";
import FieldPopover_Popover from "./components/popover/popover";
import FieldPopover_InlineValueEmpty from "./components/inline/value-empty";
import FieldPopover_InlineValueNotEmpty from "./components/inline/value-not-empty";
import FieldPopover_FormValueEmpty from "./components/form/value-empty";
import FormFieldWithPopoverValueNotEmpty from "./components/form/value-not-empty";
import ProtoField_PickerValueEmpty from "../../proto/components/picker/value-empty";
import FieldProto_PickerValueNotEmpty from "../../proto/components/picker/value-not-empty";
import FieldPopover_View from "./render/view";
import FieldPopover_ViewSmall from "./render/view-small";
import FieldPopover_Picker from "./render/picker";
import FieldPopover_InlineEditable from "./render/inline-editable";
import FieldPopover_FormElement from "./render/form-element";
import FieldPopover_FormElementView from "./render/form-element-view";
import FieldConfig from "../../proto/field-config";
import FieldPopover_Editable from "./render/editable/editable";
import FieldPopover_GlistEditable from "./render/glist-editable";


export default class FieldPopover extends FieldProto {

    constructor(config:FieldConfig) {

        super(config);

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.components = {
            PopoverMenu:            FieldPopover_Popover,
            FormValueEmpty:         FieldPopover_FormValueEmpty,
            FormValueNotEmpty:      FormFieldWithPopoverValueNotEmpty,

            PickerValueEmpty:       ProtoField_PickerValueEmpty,
            PickerValueNotEmpty:    FieldProto_PickerValueNotEmpty,
        }

        this.components.InlineValueEmpty        = FieldPopover_InlineValueEmpty
        this.components.InlineValueNotEmpty     = FieldPopover_InlineValueNotEmpty

        this.renderComponents.view              = FieldPopover_View
        this.renderComponents.viewSmall         = FieldPopover_ViewSmall
        this.renderComponents.formElement       = FieldPopover_FormElement
        this.renderComponents.formElementView   = FieldPopover_FormElementView
        this.renderComponents.picker            = FieldPopover_Picker
        this.renderComponents.inlineEditable    = FieldPopover_InlineEditable
        this.renderComponents.glistEditable     = FieldPopover_GlistEditable
        this.renderComponents.editable          = FieldPopover_Editable
    }
}
